<template>
  <div class="page">
    <div class="logo">
      <img src="@/assets/img/238.png" alt="">
    </div>
    <div class="title">流量王卡</div>
    <van-field
      v-model="iccid"
      name="mobile"
      label="号码："
      label-width="50px"
      placeholder="请输入您要激活的卡号"
      :rules="[{ required: true, message: '请输入您要激活的卡号' }]"
    />
    <van-button class="bu_tn" round block type="info" native-type="submit">确认</van-button>
    <div class="footer">
      <img src="@/assets/img/239.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      iccid: ''
    }
  }
}
</script>

<style lang="less" scoped>
.page{
    background: url('../../assets/img/240.png') no-repeat top center;
    background-size:100%;
    position: relative;
    padding-top:84px;
    height: calc(100% - 84px);
    .logo{
        width: 234px;
        height:75px;
        margin:0 auto 60px auto;
        img{
            height:100%;
            width:100%;
        }
    }
    .title{
        color: #0088D6;
        font-size:34px;
        text-align: center;
        font-family: HarmonyOS_Sans_SC_Black;
        font-weight:bold;
    }
    .van-cell{
        width: 85%;
        margin: 30px auto 10px auto;
        background: #F6F6F6;
        height:52px;
        border-radius: 26px;
        align-items: center
    }
   ::v-deep .van-cell__title{
        color: #4C4C4C;
        font-size:14px;
    }
    .bu_tn{
        width: 85%;
        height:52px;
        margin: auto;
        font-size:14px;
    }
    .footer{
        position: absolute;
        width:170px;
        height:32px;
        bottom: 40px;
        left:0;
        right:0;
        margin:auto;
        img{
            width:100%;
        }
    }
}
</style>

